var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"value":_vm.progress >= 0,"timeout":-1}},[_vm._v(" "+_vm._s(_vm.text || _vm.$t("global.downloading"))+" "),_c('VProgressLinear',{attrs:{"buffer-value":_vm.progress,"value":_vm.progress,"stream":"","color":_vm.progress !== 100 ? 'accent' : 'success'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }